"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlgorithmEditor = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var DecisionNodeEditor_1 = require("./DecisionNodeEditor");
var Engagement_1 = require("Common/Engagement");
var styles = __importStar(require("./AlgorithmEditor.css"));
var AlgorithmEditor = function (_a) {
    var engagementLevel = _a.engagementLevel, rootNode = _a.rootNode, onChange = _a.onChange;
    if (rootNode == undefined) {
        return react_1.default.createElement(kaleidoscope_1.Text, null, "This engagement level is turned off. Use the toggle to turn it on.");
    }
    if (rootNode.kind === "EXPRESSION") {
        return (react_1.default.createElement(kaleidoscope_1.Alert, { heading: "Unexpected data found", alertType: kaleidoscope_1.AlertType.Error }, "hmm the algorithm for this engagement level appears to be corrupted. You can try toggling it off and on again to clear the corrupted data."));
    }
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "l" },
        react_1.default.createElement(kaleidoscope_1.Text, { size: "s", className: styles.introSentence, element: "div" },
            "This page is",
            " ",
            react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true }, (0, Engagement_1.getEngagementLevelDisplayName)(engagementLevel)),
            " ",
            "when"),
        react_1.default.createElement(DecisionNodeEditor_1.DecisionNodeEditor, { engagementLevel: engagementLevel, node: rootNode, onChange: onChange })));
};
exports.AlgorithmEditor = AlgorithmEditor;
